<template>
  <div>
    <label>{{ titleKey | setText(title) }}</label>
    <select @change="input" v-model="val" class="form-control mb-2">
      <option value="">Выберите</option>
      <option :value="l" v-for="(l, k) in list" :key="k">
        {{ l.label }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    data: {
      default: function () {
        return {};
      },
    },
    link: {
      default: "",
    },
    title: {
      default: "",
    },
    titleKey: {
      default: "",
    },
    method: {
      default: "GET",
    },
  },
  async created() {
    await this.getList();
  },
  watch: {
    link(val) {
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    input() {
      setTimeout(() => {
        this.$emit("input", this.val);
      }, 10);
    },
    getList() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}${this.link}`,
        method: this.method,
        headers: {
          "agent-id": this.partner["api_public_key"],
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: this.data,
      })
        .then((response) => {
          if (response.data) {
            this.list = response.data;
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      list: [],
      val: {},
    };
  },
};
</script>

